interface ServiceTerminationNoticeProps {
  onConfirm: () => void;
}

export function ServiceTerminationNotice({ onConfirm }: ServiceTerminationNoticeProps) {
  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-gray-950/60 px-4 py-6">
      <div className="max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-[28px] bg-gray-200 p-6 shadow-2xl sm:p-8">
        <div className="mb-6 border-b border-gray-400 pb-4">
          <p className="text-sm font-semibold tracking-[0.18em] text-gray-600">SERVICE NOTICE</p>
          <h1 className="mt-2 text-2xl font-bold text-gray-900 sm:text-3xl">에코딜 서비스 종료 안내</h1>
        </div>

        <div className="space-y-5 text-sm leading-7 text-gray-800 sm:text-base">
          <p>안녕하세요, 에코딜입니다.</p>
          <p>
            그동안 에코딜 서비스를 이용해 주신 모든 고객 여러분께 진심으로 감사드립니다.
            내부적인 사정으로 인해 에코딜 서비스를 종료하게 되었음을 알려드립니다.
            서비스를 믿고 이용해 주신 고객 여러분께 충분한 만족을 드리지 못한 점 진심으로 사과드립니다.
          </p>

          <section>
            <h2 className="mb-2 text-base font-bold text-gray-900 sm:text-lg">서비스 종료 일정</h2>
            <p>서비스 종료일 : 2026년 3월 10일</p>
          </section>

          <section>
            <h2 className="mb-2 text-base font-bold text-gray-900 sm:text-lg">유의사항</h2>
            <ul className="space-y-1">
              <li>종료일 이후 신규 주문 및 결제가 불가합니다.</li>
              <li>미처리 주문 및 환불 관련 문의는 2026년 3월 10일 이전까지 고객센터로 연락 주시기 바랍니다.</li>
              <li>개인정보는 관련 법령에 따라 처리될 예정입니다.</li>
            </ul>
          </section>

          <section>
            <h2 className="mb-2 text-base font-bold text-gray-900 sm:text-lg">문의</h2>
            <p>이메일 : ecodeal_cs@ecodeal.kr</p>
          </section>

          <p>
            짧은 시간이었지만 에코딜을 찾아주신 모든 분들께 감사드리며,
            고객 여러분의 앞날에 늘 좋은 일만 가득하시길 바랍니다.
          </p>
          <p className="font-semibold text-gray-900">에코딜 드림</p>
        </div>

        <button
          type="button"
          onClick={onConfirm}
          className="mt-8 w-full rounded-2xl bg-gray-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-black"
        >
          확인했습니다
        </button>
      </div>
    </div>
  );
}
